import { render, staticRenderFns } from "./BourdonReport.vue?vue&type=template&id=92545cb6&scoped=true&"
import script from "./BourdonReport.vue?vue&type=script&lang=js&"
export * from "./BourdonReport.vue?vue&type=script&lang=js&"
import style0 from "./BourdonReport.vue?vue&type=style&index=0&id=92545cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92545cb6",
  null
  
)

export default component.exports